"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bohrMagnetonDependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _dependenciesUnitClassGenerated = require("./dependenciesUnitClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var bohrMagnetonDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated.UnitDependencies,
  createBohrMagneton: _factoriesAny.createBohrMagneton
};
exports.bohrMagnetonDependencies = bohrMagnetonDependencies;